import { createVNode, render } from 'vue'
import modal from './modal.vue'
import { getSceneParams, execSceneRule } from './api'
import { isValidData } from '/@/utils/is';

//合规管控支持业务场景
const ruleConfigs = [
  { business: 'project_group', code: 'project_group_submit' },
  { business: 'project', code: 'project_submit'},
  { business: 'task', code: 'task_submit'},
  { business: 'information', code: 'info_delivery_submit'},
  { business: 'statement', code: 'statement_submit'}
]

export enum ActionCodeEnum {
  RejectSubmit = 'reject_submit',
  WarnPrompt = 'warn_prompt',
  ComplianceApproval= 'compliance_approval', 
  AutoReject = 'auto_reject',
  AutoMosaic = 'auto_mosaic'
}

const createRuleModal = ({ isCancelBtn = false, ruleDatas, onOk = null, onCancel = null }) => {
  if (!Array.isArray(ruleDatas) || ruleDatas.length == 0) return;

  const container = document.createElement('div');
  const instance = createVNode(modal, { isCancelBtn, ruleDatas, onOk, onCancel });
  render(instance, container);
  document.body.appendChild(container);

  return instance.component?.exposed;
}

//合规管控对象
export const Compliance = ({ business = '', sceneCode = ''}) => {
  let scenes = []
  //初始化当前业务的所有规则及参数
  const init = async () => {
    // 按业务模式处理
    if(business) {
      const rules = ruleConfigs.filter(item => item.business == business)
      let res = []
      try {
        res = await Promise.all(rules.map(item => getSceneParams(item.code)))
      } catch (error) {
        res = []
      }

      if(res.length == 0) return

      scenes = rules.map((r,i) => { return { sceneCode: r.code, params: res[i] }})
    }
    // 按场景处理
    if(sceneCode) {
      let params = []
      try {
        params = await getSceneParams(sceneCode)
      } catch (error) {
        params = []
      }
      if(params.length == 0) return

      scenes = [{ sceneCode, params }]
    }
  }

  //规则执行
  const execute = async ({ sceneCode, params }) => {
    const scene = scenes.find(item => item.sceneCode === sceneCode)
    if(!scene) {
      return new Promise(resolve => resolve([]))
    }

    const req = {}
    scene.params.forEach(p => {
      req[p.code] = params[p.code]
    })

    return new Promise(async (resolve, reject) => {
      // 如果合规管控的参数存在非合法数据，则放行
      let valid = Object.keys(req).every(key => isValidData(req[key]))
      if(!valid) {
        return resolve([])
      }

      const res  = await execSceneRule(sceneCode, req)

      if(res.length == 0) resolve([])
      else {
        if(res[0].actionCode == ActionCodeEnum.RejectSubmit) {
          createRuleModal({
            ruleDatas: res
          })
          reject(res)
        } else {
          createRuleModal({
            isCancelBtn: true,
            ruleDatas: res,
            onOk: () => { resolve(res) },
            onCancel: () => { reject(res) },
          })
        }
      }
    })
  }

  init()

  return { execute, scenes }
}
